export default {
    chatManage: {
        chat: 'Chat',
        stopOutput: 'Stop',
        pleaseEnterChatContent: 'Enter chat content, Shift+Enter to line break',
        send: 'Send',
        fileSizeLessThan15MB: 'File size must be less than 15MB!',
        pleaseEnterContent: 'Please enter content',
        imageUploadFailed: 'Image upload failed',
        fileUploadFailed: 'File upload failed',
        client: 'Client ',
        exportChat: 'Export conversations',
        pleaseSelectClient: 'Select client',
        exportAllChat: 'Export all conversations',
        exportPartialChat: 'Export specified conversations',
        all: 'All',
        unread: 'Unread',
        haveRead: 'Have Read',
        noData: 'No Data',
        manual: 'Manual',
        export: 'Export',
        exportChatTitle: 'Export Messages',
        exportTip: 'To avoid data overload, please export after filtering by session time, and the time span must be within {count} days.',
        sessionTime: 'Session Time',
        startDate: 'Start Date',
        endDate: 'End Date',
        selectChatTip: 'You can select up to 30 sessions for export at a time.',
        pleaseSelectChat: 'Please select the chat records to be exported',
        pleaseSelectTimeRange: 'Please select the time range',
        exportChatRecord: 'Chat Record Export',
        replyMode: 'Reply Mode：',
        manualReply: 'Manual Reply',
        aiReply: 'AI Reply',
        groupReply: 'Group Reply',
        transferToManual: 'Transfer to Manual',
        haveProcessed: 'Have Processed',
        AICustomerProfile: 'AI Customer Profile',
        AIAssistantGenerateReply: 'AI Assistant Generate Reply',
        confirmTransferToManual: 'Are you sure to transfer to manual customer service?',
        manualCustomerService: 'Manual Customer Service',
        switchSuccess: 'Switch Success',
        confirmTransferToAI: 'Are you sure to transfer to AI customer service?',
        intelligentCustomerService: ' AI Customer Service',
        contentIsNotCompliant: 'Content is not compliant, please try another question~',
        copySuccess: 'Copy Success',
        pleaseEnterMessage: 'Please enter message',
        NoPrivie: {
            title: 'Chat Management',
            description: 'Aggregate management of all dialogues through intelligent agent access channels, with smart switching between AI responses and human responses.One-stop management of dialogue users across all channels, adding customer tags and generating customer profiles based on intelligent data analysis.',
            chatManage: 'Chat Management',
            chatManageDescription: 'Unified multi-channel conversation view',
            chatManageDescription2: 'Real-time sync & exportable chat records',
            chatManageDescription3: 'AI-assisted replies during manual handoff',
            transferToManual: 'Transfer to Manual',
            transferToManualDescription: 'Support configuring visibility permissions for human agent',
            transferToManualDescription2: 'Smart conversation summary generation after handoff',
            transferToManualDescription3: 'One-click AI/manual reply switching',
            customerManage: 'Customer Management',
            customerManageDescription: 'One-stop cross-channel user management',
            customerManageDescription2: 'AI-powered customer tagging',
            customerManageDescription3: 'Convenient customer profile access',
        }
    }
}